import * as React from "react";
const SvgHeygen = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "white" }),
  /* @__PURE__ */ React.createElement("rect", { x: 4, y: 4, width: 12, height: 12, rx: 1, fill: "#7559FF" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.6961 9.46556L7.91287 6.0836C7.5076 5.84618 7 6.1427 7 6.61753V13.3825C7 13.8573 7.50658 14.1538 7.91287 13.9164L13.6961 10.5345C14.1013 10.2971 14.1013 9.70403 13.6961 9.46658V9.46556Z",
      fill: "white"
    }
  )
);
export default SvgHeygen;
